import { useEffect, useMemo }               from "react";

import {
  TEMPLATE_COPY_CODE,
  TEMPLATE_COPY_CODE_TEXT,
  LTO_OFFERCODE_EXPIRE_IN,
}                                           from "./constant";
import WhatsAppPreview                      from "./WhatsAppPreview";

// Stable sentinel for the `variables` default below — a fresh `[]` literal in the destructuring
// default would change reference on every render even when the caller never passes this prop
// (every current call site omits it), which would defeat the `data` memo just below.
const EMPTY_VARIABLES = [];

// This is the component the rest of the app imports. It normalises props and renders
// the panel (WhatsAppPreview, in ./WhatsAppPreview.js).
const TemplatePreview = (props) => {

  const {
    width,
    height,
    template,
    variables           = EMPTY_VARIABLES,
    showHeading         = true,
    scrollOnhover       = true,
    isInPreview         = false,
    bypassMediaUrlCheck = false,
    hidePreview         = false,
    // Change #1: optional media-url validator, forwarded through config to
    // WhatsAppPreview (./WhatsAppPreview.js), which defaults it and threads it down to
    // Header.js / OrderDetails.js / CarouselCardPanel.js. Omit it entirely (leave
    // undefined) to get the "treat every url as valid" default.
    validateMediaUrl,
  } = props;

  useEffect(() => {
    if (template.containerMeta?.limitedTimeOffer?.has_expiration && !template.containerMeta.ltoOfferCodeExpireIn) {
      template.containerMeta.ltoOfferCodeExpireIn = LTO_OFFERCODE_EXPIRE_IN;
    }
    template?.containerMeta?.buttons && template?.containerMeta?.buttons.forEach((btn) => (btn.type === TEMPLATE_COPY_CODE && !btn.text) && (btn.text = TEMPLATE_COPY_CODE_TEXT));
  }, [template]);

  // Memoized so a re-render that leaves every one of these inputs referentially unchanged hands
  // WhatsAppPreview.js the same `config` reference back — its own containerMeta memo (keyed on
  // `[meta, config]`) can then actually short-circuit, instead of every render being treated as
  // "config changed" purely because this object literal was rebuilt from scratch.
  const data = useMemo(() => ({
    width               : width ?? "",
    height              : height ?? "",
    templateObj         : template || "",
    showHeading         : showHeading,
    isInPreview         : isInPreview,
    isScrollOnHover     : scrollOnhover,
    bypassMediaUrlCheck : bypassMediaUrlCheck,
    hidePreview         : hidePreview,
    card_variables      : template?.containerMeta?.cards
      ?.filter((card) => card.mediaId && !card.mediaUrl)
      .map((card) => ({ mediaURL: card.mediaUrl })) || [],
    validateMediaUrl    : validateMediaUrl,
    ...variables.length > 0 && {
      variables : variables,
    }
  }), [
    width, height, template, showHeading, isInPreview, scrollOnhover,
    bypassMediaUrlCheck, hidePreview, validateMediaUrl, variables,
  ]);

  return <WhatsAppPreview config = {data} />;
};

export default TemplatePreview;
